import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { planHasWatermark } from 'fym-shared/src/music24/watermarkUpsell';
import { openSMLUpgradePrompt } from '../../../redux/slices/appInfo/slice';
import { useIsDemoAccount } from '../../accountSelector/useIsDemoAccount';
import { SMLUpgradeFeature } from '../config/music24PlanCapabilities';
import { useMusic24Plan } from '../hooks/useMusic24Plan';

export const UPSELL_QUERY_PARAM = 'upsell';
export const UPSELL_QUERY_WATERMARK = 'watermark';

/**
 * `?upsell=watermark` on any `/app` page (the links of the trial emails and of the push): opens the
 * offer one time and removes the parameter from the address, so a reload or the return from the
 * checkout does not open it again. A plan with no watermark and the demo artist only lose the
 * parameter.
 */
export function useUpsellQueryParam(): void {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const plan = useMusic24Plan();
  const isDemo = useIsDemoAccount();
  const isAsked = searchParams.get(UPSELL_QUERY_PARAM) === UPSELL_QUERY_WATERMARK;

  useEffect(() => {
    if (!isAsked) {
      return;
    }
    const next = new URLSearchParams(searchParams);
    next.delete(UPSELL_QUERY_PARAM);
    setSearchParams(next, { replace: true });
    if (planHasWatermark(plan) && !isDemo) {
      dispatch(openSMLUpgradePrompt({ feature: SMLUpgradeFeature.watermark, upsellSurface: 'email' }));
    }
    // Only when the parameter shows: the plan of that moment decides.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAsked]);
}
